/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your lines…`)
};

const es_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega tus líneas…`)
};

const de_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie Ihre Zeilen ein…`)
};

const nl_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak uw regels…`)
};

const fr_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez vos lignes…`)
};

const it_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla le tue righe…`)
};

const pt_br2_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole suas linhas…`)
};

const pt_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole suas linhas…`)
};

const ja_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行を貼り付け…`)
};

const zh_ls_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴你的文本行……`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_placeholder", locale)
	if (locale === "en") return en_ls_placeholder(inputs)
	if (locale === "es") return es_ls_placeholder(inputs)
	if (locale === "de") return de_ls_placeholder(inputs)
	if (locale === "nl") return nl_ls_placeholder(inputs)
	if (locale === "fr") return fr_ls_placeholder(inputs)
	if (locale === "it") return it_ls_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_ls_placeholder(inputs)
	if (locale === "pt") return pt_ls_placeholder(inputs)
	if (locale === "ja") return ja_ls_placeholder(inputs)
	return zh_ls_placeholder(inputs)
};